import React from 'react'
import SecondHeader from '../components/SecondHeader/SecondHeader'
import Footer from '../components/Footer/Footer'

const AboutUs = () => {
    return (
        <>
            <SecondHeader />

            <div className="privacy-page-box">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h1 className="common-heading page-main-heading">About Us</h1>

                            <p className="common-text pb-4">Welcome to I-Sit Corp, where innovation meets comfort. We are a forward-thinking company dedicated to revolutionizing the way people experience seating solutions, both in the workplace and at home. With a passion for ergonomic design and a commitment to sustainability, I-Sit Corp strives to create products that not only meet your needs but enhance your daily life.</p>

                            <h1 className="common-heading">Who We Are</h1>
                            <p className="common-text">At I-Sit Corp, we bring together a diverse team of experts in design, engineering, and customer service. Our mission is to provide cutting-edge seating solutions that prioritize health, productivity, and style. Founded on the principles of quality craftsmanship and customer-centric innovation, we’ve grown into a trusted name in the industry.</p>

                            <h1 className="common-heading">What We Do</h1>
                            <p className="common-text">Our product line includes a wide range of ergonomic chairs, smart seating solutions, and customizable options for businesses, individuals, and institutions. Each product is meticulously designed to improve posture, reduce strain, and promote overall well-being. Beyond seating, we are continuously exploring new ways to integrate smart technology into our designs, ensuring that our customers stay ahead in an ever-evolving world.</p>

                            <h1 className="common-heading">Our Commitment</h1><br />
                            <h1 className='common-heading sub-heading-terms-page'>Quality</h1>
                            <p className="common-text mb-0">We use only the highest quality materials and processes to ensure durability and satisfaction.</p>
                            <br />
                            <h1 className='common-heading sub-heading-terms-page'>Sustainability</h1>
                            <p className="common-text mb-0">We are committed to environmentally friendly practices, from sourcing sustainable materials to minimizing waste in production.</p>
                            <br />
                            <h1 className='common-heading sub-heading-terms-page'>Customer Satisfaction</h1>
                            <p className="common-text">Your comfort and happiness are our priorities. Our dedicated support team is always ready to assist you.</p>


                            <h1 className="common-heading">Why Choose I-Sit Corp?</h1>
                            <p className="common-text">When you choose I-Sit Corp, you’re choosing more than just a product—you’re choosing a lifestyle upgrade. Whether it’s an office chair that boosts productivity or a home solution that enhances relaxation, we deliver products that make a difference. Trusted by professionals, businesses, and families worldwide, I-Sit Corp is your partner in achieving ultimate comfort.</p>

                            <h1 className="common-heading">Our Vision</h1>
                            <p className="common-text">To redefine the seating experience through innovative design, sustainable practices, and unwavering dedication to customer satisfaction.</p>

                            <h1 className="common-heading">Connect With Us</h1>
                            <p className="common-text">Have questions or need assistance? We’re here to help. Explore our product catalog, read customer reviews, or reach out to our support team to learn more about how I-Sit Corp can transform your seating experience. <br />
                                Thank you for choosing I-Sit Corp—where comfort meets innovation.</p>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    )
}

export default AboutUs